import React from 'react';
import UserHeader from './UserHeader';

interface ProtectedLayoutProps {
  children: React.ReactNode;
}

const ProtectedLayout: React.FC<ProtectedLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <UserHeader />
      <main className="pt-0">
        {children}
      </main>
    </div>
  );
};

export default ProtectedLayout;
